/** Parse rows from GET /admin/masters/:type (paginated API body). */
export function parseMasterListRows<T = Record<string, unknown>>(body: unknown): T[] {
  if (Array.isArray(body)) return body as T[];
  if (body && typeof body === 'object') {
    const data = (body as { data?: unknown }).data;
    if (Array.isArray(data)) return data as T[];
  }
  return [];
}

export interface VehicleTypeRow {
  code: string;
  name: string;
  serviceTypes?: string;
  serviceType?: string;
}

export function vehiclesForRental(vehicleTypes: VehicleTypeRow[]): VehicleTypeRow[] {
  const rental = vehicleTypes.filter((v) => {
    const types = String(v.serviceTypes || v.serviceType || '')
      .split(',')
      .map((s) => s.trim().toUpperCase());
    return types.includes('RENTAL');
  });
  return rental.length ? rental : vehicleTypes;
}

export function vehiclesForOutstation(vehicleTypes: VehicleTypeRow[]): VehicleTypeRow[] {
  const outstation = vehicleTypes.filter((v) => {
    const types = String(v.serviceTypes || v.serviceType || '')
      .split(',')
      .map((s) => s.trim().toUpperCase());
    return types.includes('OUTSTATION') || types.includes('LOCAL');
  });
  return outstation.length ? outstation : vehicleTypes;
}
